<template>
    <v-card>
      <v-toolbar
        dark
        color="primary"
        flat
      >
        <v-toolbar-title>Modifica bozza</v-toolbar-title>
      </v-toolbar>
      <moduleStructure :id="$route.params.id" edit-mode />
    </v-card>
  </template>
  <script>
  import moduleStructure from './components/moduleStructure'
  export default {
    components: { moduleStructure },
  };
  </script>
  